export default {
  userInfo: {},
  menus: [],
  initAuthTreeData: [],
  authButtonList: [],
  urlCookie: "",
  breadNav: [], // 面包屑导航菜单列表
  role: [], // 角色
  areaList: [] // 全量的行政区划
}